import { render, staticRenderFns } from "./View25.vue?vue&type=template&id=89175220&scoped=true&"
import script from "./View25.vue?vue&type=script&lang=js&"
export * from "./View25.vue?vue&type=script&lang=js&"
import style0 from "./View25.vue?vue&type=style&index=0&id=89175220&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89175220",
  null
  
)

export default component.exports